import api from "./axiosAPI";

export const updatesAPI = {
    getUpdates: async (page, page_size = 25, filters = {}) => {
        try {
            const params = {
                ...filters,
                ...(page ? { page } : {}),
                ...(page_size ? { page_size } : {}),
            };
            const response = await api.get("/updates/", { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching updates:", error);
            throw error;
        }
    },
};
